module.exports = __webpack_public_path__ + "img/live.0399a690.png";